import { action, flow, makeObservable, observable } from "mobx";
import { DocumentSigningService } from "../../services/documentForms/documentSigningService";
import { GlobalStore } from "@roc/feature-app-core";

export class DocumentSigningStore {
  private globalStore: GlobalStore;
  documentSigningService: DocumentSigningService;
  noteAllongeErrorMessage: string;
  assignmentAndConveyanceErrorMessage: string;

  constructor(globalStore) {
    this.globalStore = globalStore;
    this.documentSigningService = new DocumentSigningService();
    makeObservable(this, {
      generateNoteAllongeDocument: flow,
      generateAssignmentAndConveyanceDocument: flow,
      validateNoteAllongeDocument: flow,
      validateAssignmentAndConveyanceDocument: flow,
    });
    this.setDefaults();
  }

  setDefaults() {

  }

  *generateNoteAllongeDocument(signature, loanId) {
    try {
      const data = {
        loanId,
        signature,
        userAgent: navigator.userAgent,
      }
      yield this.documentSigningService.generateNoteAllongeDocument(data);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Succesfully signed Note Allonge document.',
      });
    }
    catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while generating Note Allonge document.',
      });
    }

  }

  *generateAssignmentAndConveyanceDocument(signature, loanId) {
    try {
      const data = {
        loanId,
        signature,
        userAgent: navigator.userAgent,
      }
      yield this.documentSigningService.generateAssignmentAndConveyanceDocument(data);
      this.globalStore.notificationStore.showSuccessNotification({
        message: 'Succesfully signed Assignment and Conveyance document.',
      });
    }
    catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while generating Assignment and Conveyance document.',
      });
    }
  }

  *validateNoteAllongeDocument(loanId) {
    try {
      const response = yield this.documentSigningService.validateSigningDocument(loanId);
      this.noteAllongeErrorMessage = response?.data?.data?.errorMessage;
    } catch(error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while opening Note Allonge.',
      });
    }
  }

  *validateAssignmentAndConveyanceDocument(loanId) {
    try {
      const response = yield this.documentSigningService.validateSigningDocument(loanId);
      this.assignmentAndConveyanceErrorMessage = response?.data?.data?.errorMessage;
    } catch(error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while opening Assignment and Conveyance.',
      });
    }
  }
}